import { FunctionComponent } from 'react'
import Paging from './paging'
import useQueryParams from 'Frontend/hooks/useQueryParams'

interface PagingProps {
  noOfPages: number
  activePage: number
}

const PagingApp: FunctionComponent<PagingProps> = ({ noOfPages, activePage }) => {
  const { setQueryParam } = useQueryParams()
  const handlePageChange = (page: number) => {
    setQueryParam('page', page.toString())

    const url = new URL(window.location.href)
    window.location.href = url.toString()
  }

  return <Paging noOfPages={noOfPages} activePage={activePage} callback={handlePageChange} />
}

export default PagingApp
